/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleCutIcon16Solid = forwardRef('CheckCircleCutIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 15a7 7 0 0 0 6.402-9.835l-5.138 5.138a2.25 2.25 0 0 1-3.182 0L4.09 8.31a1 1 0 0 1 1.414-1.414l1.991 1.991a.25.25 0 0 0 .354 0l5.455-5.455A7 7 0 1 0 8 15Z" })));
});
